import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../../assets/style/AcademicCalendar.css';

const baseFileUrl = 'https://mis.drtrefi.edu.ph/'; // fallback base

function Calendar() {
  const [calendar, setCalendar] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCalendar = async () => {
      try {
        const { data } = await axios.get(
          'https://mis.drtrefi.edu.ph/api/calendars'
        );

        if (!isMounted) return;

        const calendars = data?.calendars ?? {};

        // sanitize structure
        const safeCalendar = Object.keys(calendars).reduce((acc, sy) => {
          acc[sy] = Array.isArray(calendars[sy])
            ? calendars[sy].map((item) => ({
                ...item,
                fileUrl: item.file_url
                  ? item.file_url.startsWith('http')
                    ? item.file_url
                    : `${baseFileUrl}${item.file_url}`
                  : null
              }))
            : [];
          return acc;
        }, {});

        setCalendar(safeCalendar);
        setError(null);
      } catch (err) {
        console.error('API Error:', err);
        if (isMounted) {
          setError('Failed to fetch calendar. Please try again later.');
          setCalendar({});
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchCalendar();

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return <div className="loading-message">Loading calendar...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="main-container">
      <div className="calendar-header">
        <h3>SCHOOL CALENDAR</h3>
        <hr className="my-1" />
      </div>

      <div className="departments mt-4">
        {Object.keys(calendar).length > 0 ? (
          Object.entries(calendar).map(([sy, departments]) => (
            <div key={sy} className="school-year-section">
              <h4>SCHOOL YEAR: {sy}</h4>

              <div className="department-list">
                {departments.length > 0 ? (
                  departments.map(({ id, department, fileUrl }) => (
                    <div key={id} className="department-item">
                      <span className="department-name">
                        {department || 'Unknown Department'}
                      </span>

                      {fileUrl ? (
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noreferrer"
                          download
                          className="btn btn-link"
                        >
                          Download
                        </a>
                      ) : (
                        <span className="text-muted">No file available</span>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="empty-text">No departments available.</p>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="empty-text">No calendar data available.</p>
        )}
      </div>
    </div>
  );
}

export default Calendar;